import { createContext, useContext, useState, useEffect } from "react";
import api from "../services/api";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Auto fetch user on load
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await api.get("/api/authenticate", { withCredentials: true });
        setUser(res.data);
      } catch (err) {
        setUser(null);
        if (err.response && err.response.status === 401) {
          // Handle unauthorized silently
          return null; // or redirect to login if needed
        }
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, []);

  const logout = async () => {
    try {
      await api.post("/api/logout", {}, { withCredentials: true });
      delete api.defaults.headers.common["X-CSRF-Token"];
      setUser(null);
    } catch (err) {
      console.error("Logout error:", err);
    }
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, logout }}>
      {children}
    </AuthContext.Provider>
  );
};


export const useAuth = () => useContext(AuthContext);